export const electricityOptionVariants: Record<string, [number, number][]> = {
  FO: [
    [3.3, 16],
    [3.4, 16],
    [3.6, 16],
    [3.7, 16],
  ],
  FOi: [
    [3.3, 16],
    [3.4, 16],
    [3.6, 16],
    [3.7, 16],
  ],
  GF: [
    [3.7, 20],
    [5.4, 32],
    [5.6, 32],
  ],
  PE: [
    [7.3, 32],
    [7.4, 32],
    [9.2, 40],
    [11.1, 48],
  ],
  PEi: [
    [7.3, 32],
    [7.4, 32],
    [9.2, 40],
    [11.1, 48],
  ],
  MO: [
    [1.6, 16],
    [2.3, 16],
    [2.7, 16],
    [3.1, 16],
    [3.6, 16],
  ],
  MOi: [
    [1.6, 16],
    [2.3, 16],
    [2.7, 16],
    [3.1, 16],
    [3.6, 16],
  ],
  FV: [
    [1.9, 16],
    [3.1, 16],
    [3.3, 16],
  ],
  FC: [
    [2.65, 16],
    [3.3, 16],
    [3.4, 16],
  ],
  VA: [
    [3.6, 16],
    [3.7, 20],
  ],
  TS: [
    [0.32, 10],
    [0.82, 10],
  ],
};
